var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageRouter, PageRoute } from './PageRouter';
import AccountHome from '../account/AccountHome';
import AddProfileEmail from '../account/AddProfileEmail';
import AdminHome from '../admin/AdminHome';
import OrganizationsHome from '../organizations/OrganizationsHome';
import InvestmentsHome from '../investments/InvestmentsHome';
import WorkHome from '../work/WorkHome';
import Home from '../home/Home';
import DealflowHome from '../dealflow/DealflowHome';
import { EventListPage } from '../events/event-list-page';
import OrganizationHome from '../organizations/OrganizationHome';
import EditOrganization from '../organizations/EditOrganization';
import CapTableData from '../cap-table/CapTableData';
import DebtNote from '../cap-table/debt-notes/DebtNote';
import UpdateDebtNote from '../cap-table/debt-notes/UpdateDebtNote';
import UpdateDebtTerm from '../cap-table/debt-terms/UpdateDebtTerm';
import OptionGrant from '../cap-table/option-grants/OptionGrant';
import UpdateOptionGrant from '../cap-table/option-grants/UpdateOptionGrant';
import UpdateSafeTerm from '../cap-table/safe-terms/UpdateSafeTerm';
import Safe from '../cap-table/safe-certificates/Safe';
import UpdateSafe from '../cap-table/safe-certificates/UpdateSafe';
import UpdateShareClass from '../cap-table/share-classes/UpdateShareClass';
import UpdateWarrantBlock from '../cap-table/warrant-blocks/UpdateWarrantBlock';
import ShareCertificate from '../cap-table/share-certificates/ShareCertificate';
import UpdateShareCertificate from '../cap-table/share-certificates/UpdateShareCertificate';
import AdminUserList from '../admin/AdminUserList';
import AdminUserDetails from '../admin/AdminUserDetails';
import UpdateOptionPlan from '../cap-table/option-plans/UpdateOptionPlan';
import WarrantGrant from '../cap-table/warrant-grants/WarrantGrant';
import UpdateWarrantGrant from '../cap-table/warrant-grants/UpdateWarrantGrant';
import { ContentDetailsData } from '../content/ContentDetailsData';
import ContentHome from '../content/ContentHome';
import UpdateContent from '../content/UpdateContent';
import SharesPage from '../cap-table/shares/shares-page';
import { EventDetailsPage } from '../events/event-details-page';
import { UpdateEventPage } from '../events/update-event-page';
import { OptionsPage } from '../cap-table/options/options-page';
import { ConvertiblesPage } from '../cap-table/convertibles/convertibles-page';
import { SafesPage } from '../cap-table/safes/safes-page';
import { WarrantsPage } from '../cap-table/warrants/warrants-page';
import { Community } from '../community/community';
export function AuthenticatedApp() {
    return (_jsxs(PageRouter, { children: [_jsx(PageRoute
            // http://localhost:3000/account/add-email
            , __assign({ 
                // http://localhost:3000/account/add-email
                title: "Add email", path: "/account/add-email", defaultHistory: ['/', '/account'], "data-test": "page-account-add-email" }, { children: _jsx(AddProfileEmail, {}, void 0) }), void 0),
            _jsx(PageRoute
            // http://localhost:3000/account
            , __assign({ 
                // http://localhost:3000/account
                title: "Account", path: "/account", defaultHistory: ['/'], "data-test": "page-account" }, { children: _jsx(AccountHome, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "User", path: "/admin/users/:userId", defaultHistory: ['/', '/admin', '/admin/users'], "data-test": "page-admin-user-details" }, { children: _jsx(AdminUserDetails, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Users", path: "/admin/users", defaultHistory: ['/', '/admin'], "data-test": "page-admin-users" }, { children: _jsx(AdminUserList, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Admin", path: "/admin", defaultHistory: ['/'], "data-test": "page-admin" }, { children: _jsx(AdminHome, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Dealflow", path: "/dealflow", defaultHistory: ['/'], "data-test": "page-dealflow" }, { children: _jsx(DealflowHome, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Cap table", path: "/organizations/:organizationId/cap-table", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                ], "data-test": "page-cap-table" }, { children: _jsx(CapTableData, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update debt note", path: "/organizations/:organizationId/debt-notes/:debtNoteId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/debt-notes',
                ], "data-test": "page-update-debt-note" }, { children: _jsx(UpdateDebtNote, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Debt note", path: "/organizations/:organizationId/debt-notes/:debtNoteId", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ], "data-test": "page-debt-note" }, { children: _jsx(DebtNote, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update debt term", path: "/organizations/:organizationId/debt-terms/:debtTermId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/debt-terms',
                ], "data-test": "page-update-debt-term" }, { children: _jsx(UpdateDebtTerm, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Convertibles", path: "/organizations/:organizationId/convertibles", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ] }, { children: _jsx(ConvertiblesPage, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update option grant", path: "/organizations/:organizationId/option-grants/:optionGrantId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/options',
                ], "data-test": "page-update-option-grant" }, { children: _jsx(UpdateOptionGrant, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Option grant", path: "/organizations/:organizationId/option-grants/:optionGrantId", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ], "data-test": "page-option-grant" }, { children: _jsx(OptionGrant, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update option plan", path: "/organizations/:organizationId/option-plans/:optionPlanId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/option-plans',
                ], "data-test": "page-update-option-plan" }, { children: _jsx(UpdateOptionPlan, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Options", path: "/organizations/:organizationId/options", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ] }, { children: _jsx(OptionsPage, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update safe term", path: "/organizations/:organizationId/safe-terms/:safeTermId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/safe-terms',
                ], "data-test": "page-update-safe-term" }, { children: _jsx(UpdateSafeTerm, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update safe", path: "/organizations/:organizationId/safes/:safeId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/safes',
                ], "data-test": "page-update-safe" }, { children: _jsx(UpdateSafe, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Safe", path: "/organizations/:organizationId/safes/:safeId", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/safes',
                ], "data-test": "page-safe" }, { children: _jsx(Safe, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Safes", path: "/organizations/:organizationId/safes", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ], "data-test": "page-safes" }, { children: _jsx(SafesPage, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update share certificate", path: "/organizations/:organizationId/share-certificates/:shareCertificateId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/share-certificates',
                ], "data-test": "page-update-share-certificate" }, { children: _jsx(UpdateShareCertificate, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Share certificate", path: "/organizations/:organizationId/share-certificates/:shareCertificateId", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/share-certificates',
                ], "data-test": "page-share-certificate" }, { children: _jsx(ShareCertificate, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Shares", path: "/organizations/:organizationId/shares", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ], "data-test": "page-shares" }, { children: _jsx(SharesPage, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update share class", path: "/organizations/:organizationId/share-classes/:shareClassId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/share-classes',
                ], "data-test": "page-update-share-class" }, { children: _jsx(UpdateShareClass, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update warrant block", path: "/organizations/:organizationId/warrant-blocks/:warrantBlockId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ], "data-test": "page-update-warrant-block" }, { children: _jsx(UpdateWarrantBlock, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update warrant grant", path: "/organizations/:organizationId/warrant-grants/:warrantGrantId/update", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                    '/organizations/:organizationId/warrant-grants',
                ], "data-test": "page-update-warrant-grant" }, { children: _jsx(UpdateWarrantGrant, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Warrant grant", path: "/organizations/:organizationId/warrant-grants/:warrantGrantId", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ], "data-test": "page-warrant-grant" }, { children: _jsx(WarrantGrant, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Warrants", path: "/organizations/:organizationId/warrants", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                    '/organizations/:organizationId/cap-table',
                ], "data-test": "page-warrant-grants" }, { children: _jsx(WarrantsPage, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update organization", path: "/organizations/:organizationId/edit", defaultHistory: [
                    '/',
                    '/organizations',
                    '/organizations/:organizationId',
                ], "data-test": "page-update-organization" }, { children: _jsx(EditOrganization, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Organization", path: "/organizations/:organizationId", defaultHistory: ['/', '/organizations'], "data-test": "page-organization" }, { children: _jsx(OrganizationHome, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Organizations", path: "/organizations", defaultHistory: ['/'], "data-test": "page-organizations" }, { children: _jsx(OrganizationsHome, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update content", path: "/content/:contentId/update", defaultHistory: ['/', '/content'], "data-test": "page-update-content" }, { children: _jsx(UpdateContent, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Content details", path: "/content/:contentId", defaultHistory: ['/', '/content'], "data-test": "page-content-details" }, { children: _jsx(ContentDetailsData, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Content", path: "/content", defaultHistory: ['/'], "data-test": "page-content" }, { children: _jsx(ContentHome, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update event content", path: "/events/:eventId/content/:contentId/update", defaultHistory: [
                    '/',
                    '/events',
                    '/events/:eventId',
                    '/events/:eventId/content/:contentId',
                ], "data-test": "page-event-update-content" }, { children: _jsx(UpdateContent, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Event content", path: "/events/:eventId/content/:contentId", defaultHistory: ['/', '/events', '/events/:eventId'], "data-test": "page-event-content-details" }, { children: _jsx(ContentDetailsData, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Update event", path: "/events/:eventId/update", defaultHistory: ['/', '/events', '/events/:eventId'], "data-test": "page-update-event" }, { children: _jsx(UpdateEventPage, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Event", path: "/events/:eventId", defaultHistory: ['/', '/events'], "data-test": "page-event-details" }, { children: _jsx(EventDetailsPage, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Events", path: "/events", defaultHistory: ['/'], "data-test": "page-events" }, { children: _jsx(EventListPage, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Investments", path: "/investments", defaultHistory: ['/'], "data-test": "page-investments" }, { children: _jsx(InvestmentsHome, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Community", path: "/community", defaultHistory: ['/'], "data-test": "page-community" }, { children: _jsx(Community, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Work", path: "/work", defaultHistory: ['/'], "data-test": "page-work" }, { children: _jsx(WorkHome, {}, void 0) }), void 0),
            _jsx(PageRoute, __assign({ title: "Home", path: "/", defaultHistory: [], "data-test": "page-home" }, { children: _jsx(Home, {}, void 0) }), void 0)] }, void 0));
}
//# sourceMappingURL=AuthenticatedApp.js.map